// Environment/config handling. Vite exposes only VITE_-prefixed variables to
// client code (see .env.example), so no server secret can leak into the
// browser bundle by accident — secrets live only in Cloudflare Functions env
// bindings (functions/api/_lib/env.js), never here.

export type AppEnvironment = 'local' | 'staging' | 'production';

export interface AppConfig {
  environment: AppEnvironment;
  apiBaseUrl: string;
  appVersion: string;
}

function resolveEnvironment(): AppEnvironment {
  const raw = (import.meta.env.VITE_APP_ENVIRONMENT || 'local').toLowerCase();
  if (raw === 'staging' || raw === 'production') return raw;
  return 'local';
}

export const appConfig: AppConfig = {
  environment: resolveEnvironment(),
  // Same-origin by default: the Worker/Functions are mounted at /api on the
  // same Pages domain as the frontend, so no cross-origin request or CORS
  // configuration is needed for the employee browser to reach the API.
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
  appVersion: import.meta.env.VITE_APP_VERSION || 'dev',
};
